const ErrorMessage = ({ content }: ErrorMessageProps) => (
  <div className="row">
    <div className="col-12">
      <div className="alert alert-danger">{content}</div>
    </div>
  </div>
);

interface ErrorMessageProps {
  content: string;
}

export default ErrorMessage;
